import { initialState, State, Action } from 'store/store';

export const loadBookmarkData = (state: State = initialState, { data }: Action) => {
  return {
    ...state,
    bookmarkLocation: data,
    bookmarkLoaded: true,
  };
};
